import { tv } from 'tailwind-variants';
import { focusStyles } from '../../styles/focusStyles.esm.js';

const toggleButtonStyles = tv({
    slots: {
        container: `
      iris:inline-flex
      iris:items-center
    `,
        base: `
      iris:group
      iris:mr-(--base-space-px-neg-1)
      iris:flex
      iris:cursor-pointer
      iris:items-center
      iris:justify-center
      iris:gap-(--comp-space-gap-toggle-button-icon)
      iris:border-(length:--comp-size-border-toggle-button)
      iris:border-solid
      iris:duration-(--comp-motion-duration-toggle-button)
      iris:ease-(--comp-motion-easing-toggle-button)
      iris:focus-visible:rounded-xs
    `,
        baseSelected: "iris:z-[1]",
        baseLeft: `
      iris:rounded-tl-(--comp-size-radius-toggle-button)
      iris:rounded-tr-(--base-space-px-0)
      iris:rounded-br-(--base-space-px-0)
      iris:rounded-bl-(--comp-size-radius-toggle-button)
      iris:border-(length:--comp-size-border-toggle-button)
    `,
        baseRight: `
      iris:mr-0
      iris:rounded-tl-(--base-space-px-0)
      iris:rounded-tr-(--comp-size-radius-toggle-button)
      iris:rounded-br-(--comp-size-radius-toggle-button)
      iris:rounded-bl-(--base-space-px-0)
      iris:border-(length:--comp-size-border-toggle-button)
    `,
        contentContainer: `
      iris:flex
      iris:min-h-[calc(var(--base-space-px-32)-2*var(--comp-size-border-toggle-button))]
      iris:min-w-[calc(var(--base-space-px-20)-2*var(--comp-size-border-toggle-button))]
      iris:items-center
      iris:justify-center
      iris:px-(--comp-space-padding-toggle-button-horizontal)
      iris:py-(--comp-space-padding-toggle-button-vertical)
      iris:font-(family-name:--comp-type-font-toggle-button)
      iris:group-data-[state=on]:cursor-default
    `,
        label: `
      iris:text-(length:--comp-type-size-toggle-button)
      iris:leading-(--comp-type-leading-toggle-button)
      iris:font-(--comp-type-weight-toggle-button-label)
      iris:tracking-(--comp-type-tracking-toggle-button)
      iris:not-italic
    `,
        icon: `
      iris:h-(--base-space-px-20)
      iris:w-(--base-space-px-20)
    `,
        iconSelected: "",
        labelSelected: "",
    },
    variants: {
        inverse: {
            false: {
                base: `
          iris:border-(--comp-color-border-toggle-button-default-rest)
          iris:bg-(--comp-color-background-toggle-button-default-rest)
          iris:hover:border-(--comp-color-border-toggle-button-default-hover)
          iris:focus-visible:border-(--comp-color-border-toggle-button-default-pressed)
          iris:active:border-(--comp-color-border-toggle-button-default-pressed)
          iris:data-[state=on]:cursor-default
          iris:data-[state=on]:border-(length:--comp-size-border-toggle-button)
          iris:data-[state=on]:border-(--comp-color-border-toggle-button-default-selected)
          iris:data-[state=on]:bg-(--comp-color-background-toggle-button-default-selected)
          ${focusStyles.default}
        `,
                contentContainer: `
          iris:group-data-[state=off]:group-hover:bg-(--comp-color-background-toggle-button-default-hover)
          iris:group-data-[state=off]:group-focus-visible:bg-(--comp-color-background-toggle-button-default-pressed)
          iris:group-data-[state=off]:group-active:bg-(--comp-color-background-toggle-button-default-pressed)
        `,
                iconSelected: `
          iris:text-(--comp-color-content-toggle-button-icon-default-selected)
          iris:hover:text-(--comp-color-content-toggle-button-icon-default-selected)
          iris:focus-visible:text-(--comp-color-content-toggle-button-icon-default-selected)
        `,
                labelSelected: `
          iris:font-(--comp-type-weight-toggle-button-label-selected)
          iris:text-(--comp-color-content-toggle-button-label-default-selected)
          iris:hover:text-(--comp-color-content-toggle-button-label-default-selected)
          iris:focus-visible:text-(--comp-color-content-toggle-button-label-default-selected)
        `,
                label: `
          iris:text-(--comp-color-content-toggle-button-label-default-rest)
          iris:focus-visible:text-(--comp-color-content-toggle-button-label-default-pressed)
          iris:data-[state=off]:hover:text-(--comp-color-content-toggle-button-label-default-hover)
          iris:data-[state=off]:active:text-(--comp-color-content-toggle-button-label-default-pressed)
        `,
                icon: `
          iris:text-(--comp-color-content-toggle-button-icon-default-rest)
          iris:focus-visible:text-(--comp-color-content-toggle-button-icon-default-pressed)
          iris:data-[state=off]:hover:text-(--comp-color-content-toggle-button-icon-default-hover)
          iris:data-[state=off]:active:text-(--comp-color-content-toggle-button-icon-default-pressed)
        `,
            },
            true: {
                iconSelected: `
          iris:text-(--comp-color-content-toggle-button-icon-inverse-selected)
          iris:hover:text-(--comp-color-content-toggle-button-icon-inverse-selected)
          iris:focus-visible:text-(--comp-color-content-toggle-button-icon-inverse-selected)
        `,
                labelSelected: `
          iris:font-(--comp-type-weight-toggle-button-label-selected)
          iris:text-(--comp-color-content-toggle-button-label-inverse-selected)
          iris:hover:text-(--comp-color-content-toggle-button-label-inverse-selected)
          iris:focus-visible:text-(--comp-color-content-toggle-button-label-inverse-selected)
        `,
                base: `
          iris:border-(--comp-color-border-toggle-button-inverse-rest)
          iris:bg-(--comp-color-background-toggle-button-inverse-rest)
          iris:hover:border-(--comp-color-border-toggle-button-inverse-hover)
          iris:focus-visible:border-(--comp-color-border-toggle-button-inverse-pressed)
          iris:active:border-(--comp-color-border-toggle-button-inverse-pressed)
          iris:data-[state=on]:border-(length:--comp-size-border-toggle-button)
          iris:data-[state=on]:border-(--comp-color-border-toggle-button-inverse-selected)
          iris:data-[state=on]:bg-(--comp-color-background-toggle-button-inverse-selected)
          ${focusStyles.inverse}
        `,
                contentContainer: `
          iris:group-data-[state=off]:group-hover:bg-(--comp-color-background-toggle-button-inverse-hover)
          iris:group-data-[state=off]:group-focus-visible:bg-(--comp-color-background-toggle-button-inverse-pressed)
          iris:group-data-[state=off]:group-active:bg-(--comp-color-background-toggle-button-inverse-pressed)
        `,
                icon: `
          iris:text-(--comp-color-content-toggle-button-icon-inverse-rest)
          iris:focus-visible:text-(--comp-color-content-toggle-button-icon-inverse-pressed)
          iris:data-[state=off]:hover:text-(--comp-color-content-toggle-button-icon-inverse-hover)
          iris:data-[state=off]:active:text-(--comp-color-content-toggle-button-icon-inverse-pressed)
        `,
                label: `
          iris:text-(--comp-color-content-toggle-button-label-inverse-rest)
          iris:focus-visible:text-(--comp-color-content-toggle-button-label-inverse-pressed)
          iris:data-[state=off]:hover:text-(--comp-color-content-toggle-button-label-inverse-hover)
          iris:data-[state=off]:active:text-(--comp-color-content-toggle-button-label-inverse-pressed)
        `,
            },
        },
    },
    defaultVariants: {
        variant: "icon",
        inverse: false,
        disabled: false,
    },
});

export { toggleButtonStyles as default };
